import AccountApi from '@/lib/api/Account'
import Logon from '@/lib/api/Logon'

const initialNotification = {
  class: 'is-dark',
  message: '',
  timeout: 3000,
  show: false,
}

export default {
  state: {
    loading: true,
    logonToken: false,
    wedSiteInfo: false,
    notification: initialNotification,
    showModalChangesUnsaved: false,
    elementsIDToFocusBeforeEachRouter: [],
    routeStoppedByChangesUnsaved: undefined,
  },

  namespaced: true,

  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload
    },

    SET_NOTIFICATION(state, payload) {
      state.notification = payload
    },

    SET_LOGON_TOKEN(state, payload) {
      state.logonToken = payload
    },

    SET_WEDSITE_INFO(state, payload) {
      state.wedSiteInfo = payload
    },

    SET_SHOW_MODAL_CHANGES_UNSAVED(state, payload) {
      state.showModalChangesUnsaved = payload
    },

    SET_ELEMENTS_ID_TO_FOCUS_BEFORE_EACH_ROUTER(state, payload) {
      state.elementsIDToFocusBeforeEachRouter = payload
    },

    SET_ROUTE_STOPPED_BY_CHANGES_UNSAVED(state, payload) {
      state.routeStoppedByChangesUnsaved = payload
    },
  },

  actions: {
    async fetchLogonToken({ commit }) {
      const logon = new Logon()
      let token
      try {
        const response = await logon.getToken('?features=wallet')
        token = response.data
      } catch (e) {
        console.error('Token de login não encontrado.')
      }
      commit('SET_LOGON_TOKEN', token)
    },

    async fetchWedSiteInfo({ commit, getters }) {
      const token = getters.logonToken
      const service = new AccountApi(token)
      const infoWedding = await service.getInfoWedding(
        token.token_payload.wed_id
      )
      commit('SET_WEDSITE_INFO', infoWedding.data.data)
    },

    setLoading(context, payload) {
      context.commit('SET_LOADING', payload)
    },

    setInitialNotification(context) {
      context.commit('SET_NOTIFICATION', initialNotification)
    },

    setNotification(context, payload) {
      const changes = Object.assign({}, initialNotification, payload)
      context.commit('SET_NOTIFICATION', changes)
    },

    setLogonToken(context, payload) {
      context.commit('SET_LOGON_TOKEN', payload)
    },

    setWedSiteInfo(context, payload) {
      context.commit('SET_WEDSITE_INFO', payload)
    },

    setShowModalChangesUnsaved(context, payload) {
      context.commit('SET_SHOW_MODAL_CHANGES_UNSAVED', payload)
    },

    setElementsIDToFocusBeforeEachRouter(context, payload) {
      context.commit('SET_ELEMENTS_ID_TO_FOCUS_BEFORE_EACH_ROUTER', payload)
    },

    setRouteStoppedByChangesUnsaved(context, payload) {
      context.commit('SET_ROUTE_STOPPED_BY_CHANGES_UNSAVED', payload)
    },
  },

  getters: {
    logonToken(state) {
      return state.logonToken
    },

    logonTokenBearer(state) {
      return state.logonToken?.token
    },

    getWedId(state) {
      return state.logonToken?.token_payload?.wed_id
    },

    getWedSiteInfo(state) {
      return state.wedSiteInfo
    },

    getWedSiteThemeId(state) {
      return state.wedSiteInfo?.site_tema
    },

    wedSiteUrl: (state) => state.wedSiteInfo?.site_url,
  },
}
